import {
  ISO_SIZE,
  IsoShapes,
  LOGO_ACCENT_COLOR,
  LOGO_INK_COLOR,
  type LogoBaseProps,
  logoA11yProps,
  scaledWidth,
} from './logoShapes';

export type LibertifyIsoProps = LogoBaseProps & {
  /** Color of the two bars. Defaults to the brand teal. */
  accentColor?: string;
};

/**
 * LibertifyIso — the Libertify brand mark on its own (no wordmark). Use it
 * where space is tight, e.g. a collapsed sidebar or a favicon-sized slot.
 *
 * @example
 * ```tsx
 * import { LibertifyIso } from '@libertify/ui';
 *
 * <LibertifyIso height={24} title={appTitle} />
 * ```
 */
export const LibertifyIso = ({
  height = ISO_SIZE.height,
  color = LOGO_INK_COLOR,
  accentColor = LOGO_ACCENT_COLOR,
  title,
  className,
  style,
}: LibertifyIsoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${ISO_SIZE.width} ${ISO_SIZE.height}`}
    width={scaledWidth(ISO_SIZE, height)}
    height={height}
    fill="none"
    className={className}
    style={style}
    {...logoA11yProps(title)}
  >
    <IsoShapes color={color} accentColor={accentColor} />
  </svg>
);

export default LibertifyIso;
